<template>
  <div class="has-text-left">
    <h5 class="text-gray-900 text-base font-semibold">{{$t("enter_bank_details")}}</h5>

    <div class="flex gap-5 mt-7 items-start flex-col md:flex-row">
      <div class="w-full md:w-1/2">
        <label
          for="bank_name"
          class="text-base text-gray-900"
        >{{$t('bank_name').tTitle()}}</label>
         <input
          v-validate="'required'"
          :class="{'input': true, 'is-danger': errors.has('bank_name') }"
          name="bank_name"
          type="text"
          :data-vv-as="translations.text.bank_name"
          :placeholder="translations.text.bank_name"
          v-model="bank_name"
          class="mt-2 bg-white"
        />
        <span
            v-show="errors.has('bank_name')"
            class="text-red text-xs pt-0.5 rtl:text-right"
          >{{ errors.first('bank_name') }}</span>
      </div>
      <div class="w-full md:w-1/2">
        <label
          for="bank_account_holder_name"
          class="text-base text-gray-900"
        >{{$t('bank_account_holder_name').tTitle()}}</label>
        <input
          v-validate="'required'"
          :class="{'input': true, 'is-danger': errors.has('bank_account_holder_name') }"
          name="bank_account_holder_name"
          type="text"
          :data-vv-as="translations.text.bank_account_holder_name"
          :placeholder="$t('bank_holder_name')"
          v-model="bank_account_holder_name"
          class="mt-2 bg-white"
        />
        <span
          v-show="errors.has('bank_account_holder_name')"
          class="text-red text-xs pt-0.5 rtl:text-right"
        >{{ errors.first('bank_account_holder_name') }}</span>
      </div>
    </div>

    <div class="mt-5">
      <div class="w-full">
        <label
          for="bank_account_number"
          class="text-base text-gray-900"
        >{{$t('bank_account_number').tTitle()}}</label>
         <input
          v-validate="'required'"
          :class="{'input': true, 'is-danger': errors.has('bank_account_number') }"
          name="bank_account_number"
          type="text"
          :data-vv-as="translations.text.bank_account_number"
          :placeholder="'00000000'"
          v-model="bank_account_number"
          class="mt-2 bg-white"
        />
        <span
            v-show="errors.has('bank_account_number')"
            class="text-red text-xs pt-0.5 rtl:text-right"
          >{{ errors.first('bank_account_number') }}</span>
      </div>
    </div>

    <h5 class="text-gray-900 text-base font-semibold mt-12 md:mt-8">{{$t("bank_enter_amount")}}</h5>

    <div class="flex gap-5 mt-9 md:mt-7 items-start flex-col md:flex-row">
      <div class="w-full md:w-auto">
        <label
          for="currency"
          class="text-base text-gray-900"
        >{{$t('currency').tTitle()}}</label>
        <div class="mt-2">
          <div class="bg-white py-3 w-full md:w-44 text-gray-900 text-base font-semibold ltr:pl-5 rtl:pr-5 rounded-md">USD</div>
        </div>
      </div>
      <div class="grow w-full md:w-auto">
        <label
          for="amount"
          class="text-base text-gray-900"
        >{{$t('amount').tTitle()}}</label>
        <input
          v-validate="'required|currency|min_value:500|max_value:50000'"
          :class="{'input': true, 'is-danger': errors.has('amount') }"
          name="amount"
          type="text"
          :data-vv-as="translations.text.amount"
          :placeholder="$t('bank_wire_min_deposit')"
          v-model="amount"
          class="mt-2 bg-white"
        />
        <span
          v-show="errors.has('amount')"
          class="text-red text-xs pt-0.5 rtl:text-right"
        >{{ errors.first('amount') }}</span>
      </div>
    </div>

    <div class="mt-5 mb-16">
      <p class="text-gray-900 text-base">{{$t('popular_deposits')}}</p>
      <div class="flex mt-2 gap-1 md:gap-2 flex-wrap xl:flex-nowrap">
        <div
          v-for="item in popularDeposits"
          :key=item
          @click="selectedPopularDeposit=item;amount=item"
          class="w-[100px] xl:w-1/6 flex-grow md:flex-grow-0 shrink-0 xl:shrink py-3 text-gray-900 text-base font-semibold rounded-md text-center bg-white border border-solid cursor-pointer focus:border-0 focus:outline-none focus:ring-0"
          :class="[selectedPopularDeposit==item?'border-green':'border-white']"
        >{{walletSymbol+item}}</div>
      </div>
    </div>
    <Button mode="secondary" @click="deposit" customClasses="!w-52 !mb-10">
      {{$t("request_details").tTitle()}}
    </Button>

    <Modal :opened="openSuccessModal" @close="redirectToPaymentHistory">
      <p class="text-xl text-green mb-5 font-bold">{{ $t('deposit_request_processing') }}</p>
      <p class="text-base text-gray-900 max-w-[560px] leading-7">{{ $t('deposit_request_processing_text') }}</p>
    </Modal>

  </div>
</template>

<script>
import Button from '@/components/reusableComponents/Button.vue'
import config from '../../../config'
import { mapGetters } from 'vuex'
import Modal from '@/components/reusableComponents/Modal.vue';

export default {
  components: { Button, Modal },
  data() {
    return {
      translations: {
        text: {
          bank_name: this.$t('bank_name'),
          bank_account_holder_name: this.$t('bank_account_holder_name'),
          bank_account_number: this.$t('bank_account_number'),
        },
      },
      currencySymbols: config.currencies,
      selectedPopularDeposit: '',
      popularDeposits: ['500', '1000', '2000', '3000','4000','5000'],
      bank_name: '',
      bank_account_holder_name: '',
      bank_account_number: '',
      amount: '',
      openSuccessModal: false
    }
  },
  watch: {
    // watcher for the i18n language change
    '$i18n.locale'() {
      this.$validator.reset()
    },
  },
  computed: {
    ...mapGetters({
      User: 'user/all',
      Language: 'language/code',
      wallet:'user/wallet'
    }),
    walletSymbol() {
      return '$';
      // return this.currencySymbols[this.wallet.currency].symbol;
    }
  },
  mounted() {},
  methods: {
    deposit() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          return false
        }
        this.$bus.$emit(
          'RequestDeposit',
          '/finance/deposit/bankwire',
          {
            // bankName: this.bank_name,
            // bankAccountHolderName: this.bank_account_holder_name,
            // bankAccountNumber: this.bank_account_number,
            amount: String(this.amount),
            userID: this.$store.state.user.info.ID,
            currency: 'USD',
            gateway: 'bankwire',
            extraInfo: JSON.stringify({ bank_name: this.bank_name, bank_account_holder_name: this.bank_account_holder_name, bank_account_number: this.bank_account_number }),
          },
          response => {
            if (response.data.success) {
              this.openSuccessModal = true
              // window.location.assign(response.data.redirectURL)
            }
          }
        )
      })
    },
    redirectToPaymentHistory(){
      this.openSuccessModal = false
      this.$router.push('/' + (this.Language || 'en') + '/finance/payment-history')
    }
  },
}
</script>
